export const noop = () => {
    return;
};
//# sourceMappingURL=noop.js.map